import { ColDef } from '@ag-grid-enterprise/all-modules'
import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import i18n from '@/lang/i18n'
import { ConfigurationAutomaticAssignmentAlgorithmResponse } from '@/modules/configurationModule/detail/automation/personnel/algorithms-definition/services/configuration-automatic-assignment-algorithm/configuration-automatic-assignment-algorithm.dto'
import { configurationAutomaticAssignmentAlgorithmService } from '@/modules/configurationModule/detail/automation/personnel/algorithms-definition/services/configuration-automatic-assignment-algorithm/configuration-automatic-assignment-algorithm.service'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { store } from '@/store/store'

export const columnsDefAutomationPersonnelAlgorithmsDefinitionGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.modal.automation.algorithm'),
            field: 'name',
            flex: 1,
            minWidth: 500,
            suppressSizeToFit: true,
            sortable: false
        }
    ]

export interface ConfigurationAutomationPersonnelAlgorithmsDefinitionGridState extends CrudModelPaginatorLaboratory<ConfigurationAutomaticAssignmentAlgorithmResponse> {
    service: typeof configurationAutomaticAssignmentAlgorithmService
    laboratoryId: number
}
export const initialConfigurationAutomationPersonnelAlgorithmsDefinitionGridState =
    (): ConfigurationAutomationPersonnelAlgorithmsDefinitionGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.local.automation.personnel.algorithm.definition',
        columnsDef: columnsDefAutomationPersonnelAlgorithmsDefinitionGrid(),
        datasource: new PaginatorLaboratoryDatasource(configurationAutomaticAssignmentAlgorithmService, store.getters.labId),
        service: configurationAutomaticAssignmentAlgorithmService,
        laboratoryId: store.getters.labId
    })
